export default {
  getBuyingTrades: state => state.buyingTrades,
  getSellingTrades: state => state.sellingTrades
}
